import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

// 画面描画中の未捕捉例外で画面全体が真っ白になるのを防ぐ。
// try/catchはReactのレンダー・コミット中の例外を捕捉できないため、
// このバウンダリでフォールバックUIを表示する。
class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            p: 4,
            minHeight: '60vh',
            textAlign: 'center',
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: '16px' }}>
            画面の表示中に問題が発生しました
          </Typography>
          <Typography sx={{ color: '#757575', fontSize: '13px' }}>
            お手数ですが、再読み込みをお試しください。
          </Typography>
          <Button variant="contained" onClick={this.handleReload}>
            再読み込み
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
